import Transformer from './transformer'
import DimensionsTransformer from './dimensions'
import DefaultTransformer from './default'
import WorldUsaTransformer from './world-usa'
import NorthAmericaTransformer from './north-america'
import { scaleLinear as scale } from 'd3-scale'

/*
 * This transformer is used when moving from a globe to a lower level (or the
 * opposite). It uses a combination of the dimensions transformer and then
 * a transformer to drill into the feature. It's implemented this way because
 * tweaking a beautiful animation from 3d space to a 2d feature was proving
 * to be way too challenging with the given time constraints.
 */
class GlobeToFeature extends Transformer {

  static match (d0, d1, opts) {
    return (!!d0 && // We have exiting nodes, which means we're loading a new feature
      d0.globe) // and the previous data was a globe
  }

  constructor (enter, exit, opts) {
    super(enter, exit, opts)

    let rotate = exit.datum().projection.rotate?.()

    this.scales = {
      dimension: scale().domain([0, .5]) // First half of the transition
                       .range([0, 1])
                       .clamp(true),
      feature: scale().domain([.5, 1]) // 2nd half of the transition
                     .range([0, 1])
                     .clamp(true)
    }

    // This transformer is used to quickly animate from 3d to 2d space
    this.dimensionTransformer = new DimensionsTransformer(exit, null, Object.assign({}, opts, {
      rotate,
      container: exit.selection()
    }))
    this.dimensionTransformer.twoPart = !!rotate

    // Then we need to determine which transformer we'll use for the 2nd part
    // of the animation. Normally it's just the DefaultTransformer, but if it's
    // USA we need a specific transformer
    let FeatureTransformer = DefaultTransformer
    if (NorthAmericaTransformer.match(enter.datum(), exit.datum(), opts)) {
      // Zooming to North America, so need a special transformer
      FeatureTransformer = NorthAmericaTransformer
    } else if (WorldUsaTransformer.match(enter.datum(), exit.datum(), opts)) {
      // Special transformer, direct to USA
      FeatureTransformer = WorldUsaTransformer
    }

    this.featureTransformer = new FeatureTransformer(enter, exit, opts)
  }

  transform (t) {
    if (t < .5) {
      this.dimensionTransformer.transform(this.scales.dimension(t))
    } else {
      this.featureTransformer.transform(this.scales.feature(t))
    }
  }

}

export default GlobeToFeature
